import { makeStyles } from "@material-ui/core/styles";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import { green, blue, blueGrey } from "@material-ui/core/colors";

const useStyles = makeStyles(theme => ({
  ...dashboardStyle,
  cardTitle: {
    marginTop: "0",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    color: "#999 !important",
    fontWeight: "400 !important",
    fontSize: "14px !important",
    lineHeight: "1.42857 !important",
    letterSpacing: "unset !important",
    padding: "10px",
    marginRight: "10px"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700]
    }
  },
  buttonLimpiar: {
    backgroundColor: blueGrey[500],
    "&:hover": {
      backgroundColor: blueGrey[700]
    }
  },
  buttonRegistra: {
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700]
    }
  },
  separacion: {
    padding: "10px",
    marginRight: "10px"
  },
  rootB: {
    "&:before": {
      borderBottomColor: "lightgrey !important"
    },
    "&:after": {
      borderBottomColor: "lightgrey !important"
    }
  },
  container: {
    textAlign: "center"
  },
  content: {
    display: "inline-flex",
    padding: "10px",
    alignItems: "center"
  },
  paddingBottomCard: {
    paddingBottom: "40px"
  },
  marginRight: {
    marginRight: "10px"
  },
  marginBottom: {
    marginBottom: "50px"
  },
  formControl: {
    marginTop: theme.spacing(3.5),
    minWidth: "100%"
  },
  formControlMid: {
    marginTop: theme.spacing(3.5),
    minWidth: "50%"
  },
  formControlSeven: {
    marginTop: theme.spacing(3.5),
    minWidth: "70%"
  },
  checkControl: {
    marginTop: theme.spacing(5)
  },
  formControlDate: {
    marginTop: theme.spacing(1.5),
    minWidth: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  showSpinner: {
    float: "right",
    display: "block"
  },
  hideSpinner: {
    display: "none"
  },
  disabledSelect: {
    opacity: "0.5 !important"
  },
  enableSelect: {
    opacity: "1 !important"
  }
}));
export { useStyles };
